import React from 'react'
import styles from './MediaDetailPanel.module.scss'

interface MediaDetailPanelProps {
  children: React.ReactNode
  className?: never
}

export const MediaDetailPanel: React.FC<MediaDetailPanelProps> = ({ children }) => (
  <div className={styles.panel}>{children}</div>
)
